<template>
    <div id="app" class="min-h-screen">
        <NavBar v-if="isAuthenticated" />
        <main :class="{ 'pt-16': isAuthenticated }">
            <router-view />
        </main>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useTheme } from '@/composables/useTheme'
import NavBar from '@/components/NavBar.vue'

const authStore = useAuthStore()
const { initTheme } = useTheme()

const isAuthenticated = computed(() => authStore.isAuthenticated)

let cleanup: (() => void) | undefined

onMounted(async () => {
    // Initialize theme first
    cleanup = initTheme()
    
    if (authStore.token) {
        await authStore.verifyToken()
    }
})

onUnmounted(() => {
    cleanup?.()
})
</script>